// extracted by mini-css-extract-plugin
module.exports = {"infobox":"infobox_infobox__jNZcZ","infobox--os":"infobox_infobox--os__oAfy1","infobox--success":"infobox_infobox--success__io9qX"};